import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../EnachCard.module.scss';
import { AlertIcon } from '@navi/web-ui/lib/icons';
import { getFormattedEnachDate } from './utils';
import cx from 'classnames';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';

type AutopayFailedProps = {
  enachCardText: string;
  enachCardDate: string;
  checkDateParsable: boolean;
  date: string;
};

const AutopayFailed = (props: AutopayFailedProps) => {
  const { enachCardText, enachCardDate, checkDateParsable, date } = props;
  return (
    <>
      <div className={styles.enachCardErrorIcon}>
        <Tooltip placement="left">
          <TooltipContent className={'tooltipWrapper !max-w-[230px]'}>
            <Typography className="text-white" variant="p5">
              Next Autopay Eligible from <strong>{date}</strong>
            </Typography>
          </TooltipContent>
          <TooltipTrigger>
            <AlertIcon color={'var(--navi-color-red-base)'} />
          </TooltipTrigger>
        </Tooltip>
      </div>
      <div className={styles.enachCardEnachStatus}>
        <Typography variant="p3" className={styles.enachStatusText}>
          Autopay Failed {checkDateParsable ? '\u00A0' : ':'}
        </Typography>
      </div>
      {checkDateParsable ? (
        <div className={styles.enachCardEnachStatus}>
          {enachCardDate ? (
            <Typography variant="p3" className={cx(styles.enachStatusText, styles.enachStatusDate)}>
              ({getFormattedEnachDate(enachCardDate)}) :
            </Typography>
          ) : (
            <Typography variant="p3" className={cx(styles.enachStatusText, styles.enachStatusDate)}>
              (NA) :
            </Typography>
          )}
        </div>
      ) : null}
      <div className={styles.enachCardFailureReason}>
        <Typography variant="p3" className={styles.enachFailureReasonText}>
          {enachCardText}
        </Typography>
      </div>
    </>
  );
};

export default AutopayFailed;
